import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { PATHS } from './paths';

const ProtectedRoute = ({ allowed, subsId }) => {
  if (!allowed) {
    if (subsId === null) {
      return <Navigate to={PATHS.PRICING} replace />;
    }
    return <Navigate to={PATHS.CHATBOT} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
